import RolesUtil from 'permissions/utils/roles';
const NotesPermissions = {
  canManageNotes: (stateData, projectID) =>
    RolesUtil.doesUserHavePPMDRoleForProject(stateData, projectID) ||
    RolesUtil.doesUserHaveEngagementOwnerRoleForProject(stateData, projectID) ||
    RolesUtil.doesUserHavePreparerReviewerRoleForProject(stateData, projectID),

  canManageCoeNotesType: (stateData, projectID) =>
    RolesUtil.doesUserHaveCoeRoleForProject(stateData, projectID) ||
    RolesUtil.doesUserHaveObserverRoleForProject(stateData, projectID) ||
    RolesUtil.doesUserHavePPMDRoleForProject(stateData, projectID) ||
    RolesUtil.doesUserHaveEngagementOwnerRoleForProject(stateData, projectID) ||
    RolesUtil.doesUserHavePreparerReviewerRoleForProject(stateData, projectID),
};

export default NotesPermissions;
